import "./Politicas.css";

export default function CancelacionReembolso() {
  return (
    <div className="politicas-container">
      <h1>Política de Cancelación, Reembolso y Derecho de Retracto</h1>

      <h2>1. Cancelación antes del envío</h2>
      <p>
        El cliente puede cancelar su pedido si ya ha sido pagado pero aún no
        ha sido enviado. Esta cancelación se procesa directamente desde su
        perfil o contactando al soporte.
      </p>
      <ul>
        <li>Se realizará el reembolso completo del monto pagado.</li>
        <li>El reembolso se hará por el mismo método de pago.</li>
        <li>Plazo estimado de reembolso: 5 a 10 días hábiles.</li>
        <li>El producto nunca sale del inventario y no afecta stock.</li>
      </ul>

      <h2>2. Pedidos ya enviados</h2>
      <p>
        Una vez el pedido ha sido enviado, no se puede cancelar. En este caso
        aplica la política de devoluciones y retracto.
      </p>

      <h2>3. Derecho de retracto (Ley colombiana)</h2>
      <p>
        Conforme al Decreto 804 de 2020, el cliente puede retractarse de su
        compra dentro de los cinco (5) días hábiles posteriores a la entrega.
        Esto aplica para compras realizadas online.
      </p>
      <ul>
        <li>El cliente debe devolver el producto en su empaque original y en buen estado.</li>
        <li>El cliente asume el costo del envío de la devolución.</li>
        <li>El reembolso se procesará una vez recibido y validado el producto.</li>
      </ul>

      <h2>4. Casos de no reembolso</h2>
      <ul>
        <li>Productos dañados por mal uso.</li>
        <li>Productos personalizados o digitales.</li>
        <li>Productos en promoción o con oferta especial marcada como “No reembolsable”.</li>
      </ul>

      <p>
        Nota: Siempre recomendamos que el cliente se comunique con soporte antes de iniciar cualquier cancelación o devolución, para garantizar un proceso rápido y seguro.
      </p>
    </div>
  );
}
